import { Grid, Stack, Typography } from '@mui/material';

import { Checkout, ProductSummary, ProductSummaryProps } from '.';

export const ConfirmProductSummary = (props: ProductSummaryProps) => {
  return (
    <Stack px={2}>
      <Typography fontSize={36} fontWeight={100} textAlign={'center'} mb={4}>
        Confirm your Product Selection
      </Typography>
      <Grid container spacing={5}>
        <Grid item xs={8}>
          <ProductSummary {...props} />
        </Grid>
        <Grid item xs={4}>
          <Checkout toggleDrawer={props.toggleDrawer} />
        </Grid>
      </Grid>
    </Stack>
  );
};
